export const ARRAY = '[]';
export const EMPTY = '';
export const UNDEFINED = 'undefined';
export const STRING = 'string';
export const DOTS = '...';
export const ZERO = 0;
export const ID = 'id';
export const defaultPage = 1;
export const defaultPageSize = 10;
export const defaultPageSizeForAttendees = 8;
export const smallPageSize = 6;
export const bigPageSize = 12;

export const defaultStep = 0;
export const NONE = 'None';
